import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UrlConstants } from '@app/core/constants/url.constants';
import { LocalStorageService } from '../services/storage/storage.service';
import { AppConstants } from '../constants/app.constants';

@Injectable({
  providedIn: 'root'
})
export class EulaGuardService implements CanActivate {
  constructor(private storageService: LocalStorageService, private router: Router) {}

  canActivate() {
    if (this.storageService.read(AppConstants.localStorageUserEulaState) !== 'true') {
      this.router.navigate([UrlConstants.eulaUrl]);
      return false;
    }
    return true;
  }
}
